import { recipientSchema, type RecipientSchema } from '@common/validation/customControls/parameterSchemas';
import { PatientEpisodeCategoryCarePathContext } from '@frontend/components/pages/episodeCategory/carePath/patientEpisodeCategoryCarePathContext';
import { useServiceWorkflowStepParameters } from '@frontend/utils';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { SelectProcessActivityPerformerOrOrganization } from '../../../processActivityPerformer/SelectProcessActivityPerformerOrOrganization';

export function HolterServiceOrganizationProvider() {
    const { activeStartingPoint, activeProcessAction } = useDefinedContext(PatientEpisodeCategoryCarePathContext);
    const { recipientActivityIds } = useServiceWorkflowStepParameters<RecipientSchema>(recipientSchema);
    const serviceId = activeStartingPoint?.service?.id ?? activeProcessAction?.serviceId;

    if (!serviceId) {
        return null;
    }

    return (
        <SelectProcessActivityPerformerOrOrganization
            recipientActivityIds={recipientActivityIds}
            serviceId={serviceId}
        />
    );
}
